import { createContext } from 'react';
import { WrappedFormUtils } from 'antd/lib/form/Form';

export const FormContext = createContext<WrappedFormUtils>({} as WrappedFormUtils);
